var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"type":"text","label":_vm.label,"error-messages":_vm.errors,"hide-details":!_vm.v.$error,"outlined":"","dense":"","disabled":_vm.disabled},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/forms/InputComponent.vue?vue&type=template&id=4cb139ea
// module id = null
// module chunks = 